import { gql } from "@apollo/client";

export const CREATE_PAYMENT_METHOD = gql`
  mutation CreatePaymentMethod(
    $accessToken: String!
    $campaignId: String!
    $paymentType: String!
    $source: String!
  ) {
    createPaymentMethod(
      accessToken: $accessToken
      campaignId: $campaignId
      paymentType: $paymentType
      source: $source
    ) {
      success
      statusCode
      message
      paymentId
      paymentType
      campaignName
    }
  }
`;
